import { defaultCurrencyValue } from 'components/Pages/Retail/PriceReport/Content/_methods'
import fakeMerchant1 from './fakeMerchant1.json'
import fakeMerchant2 from './fakeMerchant2.json'
import type { RetailPriceReportStore } from '../../types'
import type { RetailDashboard_MerchantStatsFragment } from 'api/operations'

const step0 = {
  loadingMerchant1: false,
  loadingMerchant2: false,
  query: '',
  filters: [],
  merchant1: null,
  merchantData1: null,
  merchant2: null,
  merchantData2: null,
  isTutorialOpen: false,
  currency: defaultCurrencyValue,
  startDate: null,
}
const step1 = {
  loadingMerchant1: true,
  loadingMerchant2: false,
  query: '',
  filters: [],
  merchant1: {
    name: 'Pidou Superstores',
    country: {
      codeISO: 'FR',
    },
    id: '1',
  },
  merchantData1: null,
  merchant2: null,
  merchantData2: null,
  isTutorialOpen: false,
  currency: defaultCurrencyValue,
  startDate: null,
}
const step2 = {
  loadingMerchant1: true,
  loadingMerchant2: true,
  query: '',
  filters: [],
  merchant1: {
    name: 'Pidou Superstores',
    country: {
      codeISO: 'FR',
    },
    id: '1',
  },
  merchantData1: null,
  merchant2: {
    name: 'Waitrose',
    country: {
      codeISO: 'FR',
    },
    id: '2',
  },
  merchantData2: null,
  isTutorialOpen: false,
  currency: defaultCurrencyValue,
  startDate: null,
}
const step3 = {
  loadingMerchant1: false,
  loadingMerchant2: false,
  query: '',
  filters: [],
  merchant1: {
    name: 'Pidou Superstores',
    country: {
      codeISO: 'FR',
    },
    id: '1',
  },
  merchantData1:
    fakeMerchant1 as unknown as RetailDashboard_MerchantStatsFragment,
  merchant2: {
    name: 'Waitrose',
    country: {
      codeISO: 'FR',
    },
    id: '2',
  },
  merchantData2:
    fakeMerchant2 as unknown as RetailDashboard_MerchantStatsFragment,
  isTutorialOpen: false,
  currency: defaultCurrencyValue,
  startDate: '01/01/2024',
}

export const getMockByTutorialStep = (step: number): RetailPriceReportStore => {
  if (step === 0) return step0
  if (step === 1) return step1
  if (step === 2) return step2
  if (step === 3) return step3
  // данные остаются такими же как и в step3
  if (step === 4) return step3
  if (step === 5) return step3
  if (step === 6) return step3
  return step0
}
